<template>
  <span class="checked-box-icon" aria-hidden="true">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#009246" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#009246" />
      <path
        d="M12 5L6.5 10.5L4 8"
        stroke="white"
        stroke-width="1.6666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: "CheckedBoxIcon",
};
</script>

<style lang="scss" scoped>
.checked-box-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  svg {
    display: block;
    width: 16px;
    height: 16px;
  }
}
</style>
